import LangEnum from '../../../../../../../lang/LangEnum';
import { useRachelSubmit } from '../../../../../../rachel/hooks/useRachelSubmit';
import { useTranslation } from '../../../../../../translation/TranslationContext';

export const useAskRachelAboutModes = () => {
  const { translate } = useTranslation();
  const { submit } = useRachelSubmit({ shouldStartNewChat: true });

  const ask = () => {
    void submit(translate(LangEnum.ADD_ORDER_PRODUCTS_MODE_RACHEL_PROMPT));
  };

  return { ask };
};
